const Premi = [
    {id: "0", value: "溢價"},    
    {id: "1", value: "折價"}
  ];  
  
  export default Premi  